import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

// Reusable dark hero header for inner pages
export default function PageHeader({ overline, title, subtitle, image }) {
  return (
    <section className="relative bg-purple grain overflow-hidden pt-36 pb-20 md:pt-44 md:pb-28" data-testid="page-header">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1A0F2E] via-[#1A0F2E]/70 to-[#1A0F2E]/80" />
        </div>
      )}
      <div className="relative rb-container">
        {overline && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="overline text-gold mb-5 flex items-center gap-3"
          >
            <span className="h-px w-10 bg-gold inline-block" /> {overline}
          </motion.p>
        )}
        <h1 className="font-serif font-light text-[#F6F4EE] text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95]">
          {title}
        </h1>
        {subtitle && (
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-2xl text-lg text-[#F6F4EE]/75 leading-relaxed font-light">{subtitle}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
